/* Product Carousel header arrows: drives the section's rail from a pair of circle
   buttons in the section head instead of Flickity's overlay prev/next buttons.
   Flickity only runs from 768px up (data-desktop-only); below that the rail is a
   native scroller, so the buttons scroll it by a viewport instead. */
(function () {
  'use strict';

  // The section renders this script tag per instance, so only the first copy binds.
  if (window.__productCarouselNavInit) return;
  window.__productCarouselNavInit = true;

  function bindNav(nav) {
    if (nav.dataset.navBound === 'true') return;

    // Scoped to the section wrapper so multiple Product Carousels on a page stay independent.
    var section = nav.closest('.shopify-section');
    var slider = section ? section.querySelector('.most-loved-slider') : null;
    var prev = nav.querySelector('[data-nav="previous"]');
    var next = nav.querySelector('[data-nav="next"]');
    if (!slider || !prev || !next) return;

    nav.dataset.navBound = 'true';

    // common.js destroys and rebuilds Flickity as the width crosses 768px, so look the
    // instance up each time rather than holding on to one.
    function flickity() {
      return typeof Flickity !== 'undefined' ? Flickity.data(slider) : null;
    }

    function scrollBehavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    }

    // `groupCells: true` + `wrapAround: false` means flkty.slides is the group count,
    // so the last group is the end stop. Nothing to page through -> no nav at all.
    function updateDisabled() {
      var flkty = flickity();
      if (flkty) {
        nav.hidden = flkty.slides.length < 2;
        prev.disabled = flkty.selectedIndex <= 0;
        next.disabled = flkty.selectedIndex >= flkty.slides.length - 1;
        return;
      }
      var maximum = slider.scrollWidth - slider.clientWidth;
      nav.hidden = maximum <= 1;
      prev.disabled = slider.scrollLeft <= 1;
      next.disabled = slider.scrollLeft >= maximum - 1;
    }

    function page(direction) {
      var flkty = flickity();
      if (flkty) {
        if (direction < 0) flkty.previous(); else flkty.next();
      } else {
        slider.scrollBy({ left: direction * slider.clientWidth, behavior: scrollBehavior() });
      }
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });

    // Bound to the element, not an instance, so they outlive a Flickity rebuild.
    // Flickity is built through its jQuery plugin, which also fires `select.flickity`.
    if (window.jQuery) jQuery(slider).on('select.flickity', updateDisabled);
    slider.addEventListener('scroll', updateDisabled, { passive: true });
    // Cells per group changes across breakpoints, so the end stop moves too.
    var frame = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateDisabled);
    });

    // common.js initialises Flickity asynchronously, so poll for it (same as pdp-redesign.js)
    // before settling the first state. On mobile it never arrives and the scroll state is used.
    var tries = 0;
    (function settle() {
      updateDisabled();
      if (!flickity() && tries++ < 40) setTimeout(settle, 150);
    })();
  }

  function init(scope) {
    var navs = (scope || document).querySelectorAll('[data-most-loved-nav]');
    Array.prototype.forEach.call(navs, bindNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: sections are re-rendered on change.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
